import MainContainer from "../../components/container/MainContainer";

const CashFlowReport = () => {
  return <MainContainer>CashFlowReport</MainContainer>;
};

export default CashFlowReport;
